import * as React from 'react';
import { useCallback } from 'react';
import { FrameworkForm, type FrameworkFormData } from 'components/admin/frameworks/framework-form';
import useApi from 'hooks/use-api';
import { enqueueSnackbar } from 'notistack';
import { paths } from 'paths';
import { useNavigate } from 'react-router-dom';

export default function AddFramework(): React.JSX.Element {
  const navigate = useNavigate();
  const { saveFramework } = useApi();

  const submitChanges = useCallback(
    async (data: FrameworkFormData) => {
      const newFrameworkId = await saveFramework({ ...data, id: '' });

      enqueueSnackbar('Framework added!', { variant: 'success' });

      navigate(paths.app.admin.frameworks.getDetailsUrl(newFrameworkId));
    },
    [navigate, saveFramework]
  );

  return <FrameworkForm onSubmit={submitChanges} />;
}
